import angular from 'angular';
import './call-frames-stats.scss';
import template from './call-frames-stats.html';
var ClassModificator;
(function (ClassModificator) {
    ClassModificator["Red"] = "mod-red";
    ClassModificator["Orange"] = "mod-orange";
    ClassModificator["Green"] = "mod-green";
    ClassModificator["Grey"] = "mod-grey";
})(ClassModificator || (ClassModificator = {}));
class CallFramesStatsController {
    constructor() {
        this.qualityColorMap = {
            excellent: ClassModificator.Green,
            fair: ClassModificator.Orange,
            unstable: ClassModificator.Orange,
            poor: ClassModificator.Red,
            disconnected: ClassModificator.Grey,
            default: ClassModificator.Red,
        };
    }
    mapColor(quality) {
        return this.qualityColorMap[quality] || this.qualityColorMap.default;
    }
    mapPacketLoss(packetsLost) {
        return parseFloat((packetsLost * 100).toFixed(1)) || 0;
    }
    isConnected() {
        return this.stats.estimation !== 'disconnected';
    }
}
const callFramesStatsController = {
    template,
    bindings: {
        stats: '<',
        isDesktop: '<',
    },
    controller: CallFramesStatsController,
};
export default angular
    .module('doxy.videoChat.callFrames.callFramesStats', [])
    .component('callFramesStats', callFramesStatsController).name;
